"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for subscription service
 * @param {string} message the validation message
 */
class CouldNotCreateChargeOnStripeError extends client_library_1.ExtendableError {
    constructor() {
        super('CouldNotCreateChargeOnStripe');
    }
}
exports.default = CouldNotCreateChargeOnStripeError;
//# sourceMappingURL=CouldNotCreateChargeOnStripeError.js.map